import type { CalendarEventData } from "@qendo/calendar";
import { View } from "react-native";
import { Badge, type BadgeProps, type BadgeSize } from "~/components/feedback/Badge";
import { Nothing } from "~/components/permission/Nothing";
import { Flex, Gap } from "~/constants/layout";
import { empty } from "~/util";

type StatusTagsProps = {
    event: CalendarEventData;
    size?: BadgeSize;
};

type TagProps = { show: boolean; key: string } & Omit<BadgeProps, "size">;

export const StatusTags = ({ event, size = "sm" }: StatusTagsProps) => {
    const tags = [
        { show: event.multi_day, title: "Multiple day", key: "multi-day", variant: "success" },
        { show: Boolean(event.recurrence), title: "Repeats", key: "repeats" },
        { show: event.all_day, title: "All day", key: "all-day", variant: "warning" },
    ].filter(({ show }) => show) as TagProps[];

    if (empty(tags)) {
        return <Nothing />;
    }

    return (
        <View style={[Flex.row, Gap.xs, Flex.wrap]}>
            {tags.map(({ key, ...badgeProps }) => (
                <Badge key={key} {...badgeProps} size={size} />
            ))}
        </View>
    );
};
